import vue from 'vue';
import axios from 'axios';
import config from '../config/index.js'
import $store from '../store/index.js';
import $router from '../router/index.js';
import {
  Notification
} from 'element-plus';
axios.defaults.timeout = config.timeout;
// axios.defaults.baseURL = config.http_url;

//http request 拦截器
axios.interceptors.request.use(
  config => {
    let token = $store.state.token;
    if (token) {
      config.headers = {
        'Authorization': token
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(res => {
  return res
}, err => {
  if (err.response.status === 401) {
    sessionStorage.clear();
    localStorage.clear();
    location.reload();
  }
  return Promise.reject(err.response)
})

var request = {
  /**
   * 封装get方法
   * @param url
   * @param data
   * @returns {Promise}
   */
  get (url, params = {}, baseURL = config.http_url) {
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        params: params,
        baseURL: baseURL,
      })
        .then(response => {
          resolve(response.data);
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  post (url, data = {}, config = {}) {
    return new Promise((resolve, reject) => {
      axios.post(url, data, config)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  },

  /**
   * 封装patch请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  patch (url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.patch(url, data)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  },
  /**
   * 封装put请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  put (url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.put(url, data)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  },
  /**
   * 封装delete请求
   * @param delete
   * @param data
   * @returns {Promise}
   */
  del (url, data = {}) {
    return new Promise((resolve, reject) => {
      axios.delete(url, data)
        .then(response => {
          resolve(response.data);
        }, err => {
          reject(err)
        })
    })
  }
}

export default request;
